var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"AuthButton",class:_vm.provider,attrs:{"href":_vm.url}},[_c('Btn',{attrs:{"icon":_vm.provider}},[_vm._v(" Prisijungti su "+_vm._s(_vm.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }